import { SvgProps } from '../svg'
import IconAllproperty from '@/assets/icons/portals/components/IconAllproperty'
import IconBeleta from '@/assets/icons/portals/components/IconBeleta'
import IconCyt from '@/assets/icons/portals/components/IconCyt'
import IconElInformador from '@/assets/icons/portals/components/IconElInformador'
import IconExcelsior from '@/assets/icons/portals/components/IconExcelsior'
import IconFlatmx from '@/assets/icons/portals/components/IconFlatmx'
import IconHoum from '@/assets/icons/portals/components/IconHoum'
import IconI24 from '@/assets/icons/portals/components/IconI24'
import IconIcasas from '@/assets/icons/portals/components/IconIcasas'
import IconLahaus from '@/assets/icons/portals/components/IconLahaus'
import IconLamudi from '@/assets/icons/portals/components/IconLamudi'
import IconM3 from '@/assets/icons/portals/components/IconM3'
import IconMitula from '@/assets/icons/portals/components/IconMitula'
import IconMonopolio from '@/assets/icons/portals/components/IconMonopolio'
import IconMudafy from '@/assets/icons/portals/components/IconMudafy'
import IconNeximo from '@/assets/icons/portals/components/IconNeximo'
import IconPortalterrenocom from '@/assets/icons/portals/components/IconPortalterrenocom'
import IconPropiedadescom from '@/assets/icons/portals/components/IconPropiedadescom'
import IconSegundamano from '@/assets/icons/portals/components/IconSegundamano'
import IconVivanuncios from '@/assets/icons/portals/components/IconVivanuncios'
import IconWiggot from '@/assets/icons/portals/components/IconWiggot'

export type PortalNames =
  | 'allproperty'
  | 'beleta'
  | 'cyt'
  | 'cytlease'
  | 'elinformador'
  | 'excelsior'
  | 'flatmx'
  | 'houm'
  | 'i24'
  | 'icasas'
  | 'lahaus'
  | 'lamudi'
  | 'm3'
  | 'mitula'
  | 'monopolio'
  | 'mudafy'
  | 'neximo'
  | 'portalterrenocom'
  | 'propiedadescom'
  | 'segundamano'
  | 'vivanuncios'
  | 'wiggot'

export interface IBrokerIconProps {
  name: PortalNames
  iconProps?: Omit<SvgProps, 'src'>
}
const portalIcons: Record<PortalNames, React.FC<Omit<SvgProps, 'src'>>> = {
  allproperty: IconAllproperty,
  beleta: IconBeleta,
  cyt: IconCyt,
  cytlease: IconCyt,
  elinformador: IconElInformador,
  excelsior: IconExcelsior,
  flatmx: IconFlatmx,
  houm: IconHoum,
  i24: IconI24,
  icasas: IconIcasas,
  lahaus: IconLahaus,
  lamudi: IconLamudi,
  m3: IconM3,
  mitula: IconMitula,
  monopolio: IconMonopolio,
  mudafy: IconMudafy,
  neximo: IconNeximo,
  portalterrenocom: IconPortalterrenocom,
  propiedadescom: IconPropiedadescom,
  segundamano: IconSegundamano,
  vivanuncios: IconVivanuncios,
  wiggot: IconWiggot
}

export const PortalIcon = ({ name, iconProps }: IBrokerIconProps) => {
  if (!portalIcons[name]) {
    return <></>
  }
  const Component = portalIcons[name]
  return <Component {...iconProps} />
}

export default PortalIcon
